import { RESET_CART, GET_CART } from '../actions/actionTypes';

import Cart from '../../models/Cart';

const initialState: Cart = { items: [], totalDue: 0, totalPaid: 0, remainDue: 0, pickup_date: '' };

export const cartReducer = (state = initialState, action: any) => {

  switch (action.type) {

    case RESET_CART:
      return initialState;
    case GET_CART:
      return {
        ...state,
        items: [...action.data.cart],
        totalDue: action.data.totalDue,
        totalPaid: action.data.totalPaid,
        remainDue: action.data.remainDue,
        comat: action.data.comat,
        pickup_date: action.data.pickup_date
      }

    default:
      return state;
  }

};